// Central feature-flag registry for the React client.

export const FEATURE_TARGETING_EXPERIENCE_V2 = true

// Empty arrays = all teams / all roles allowed (no filtering).
export const FEATURE_TARGETING_EXPERIENCE_V2_TEAMS = []
export const FEATURE_TARGETING_EXPERIENCE_V2_ROLES = []

// Brand refresh — switches the site-wide color palette from the legacy purple-indigo
// to the client's current deeper-blue identity via body.brand-refresh CSS class.
export const FEATURE_BRAND_REFRESH = true

